<dialog [id]="modalDialogId" class="modal">
    <div class="modal-box m-5">
        <div class="flex flex-col w-full justify-center items-center gap-5">
            <app-logo></app-logo>
            <h1 class="font-bold text-xl text-primary text-center">{{ 'dashboard.welcome_dialog.welcome_to' | transloco }}</h1>
            <p class="text-base text-neutral-500 text-center">{{ 'dashboard.welcome_dialog.free_trial' | transloco }}</p>
            <p class="text-base text-neutral-500 text-center">{{ 'dashboard.welcome_dialog.after_trial' | transloco }}</p>
            <div class="w-full">
                <app-primary-button buttonText="{{ 'dashboard.welcome_dialog.view_plans' | transloco }}" (buttonClick)="closeModal()">
                </app-primary-button>
            </div>
        </div>
    </div>
    <form method="dialog" class="modal-backdrop">
        <button>Close</button>
    </form>
</dialog>